<template>
  <div class="page-container">
    <el-card>
      <el-row class="room-sticker__title">积分抽奖配置</el-row>
      <el-row class="room-sticker__search" :gutter="20">
        <el-select
          v-model="searchData.valid"
          placeholder="请选择状态"
          style="width: 120px"
        >
          <el-option label="有效" value="1"></el-option>
          <el-option label="无效" value="0"></el-option>
        </el-select>
        <el-select
          v-model="searchData.channel"
          placeholder="请选择渠道"
          style="width: 150px"
        >
          <el-option
            v-for="(item, idx) in channelsList"
            :key="idx"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>

        <el-button @click="queryStickerBtnHandle" :loading="requestLoading">
          查询
        </el-button>
        <el-button type="primary" @click="addStickerBtnHandle(true)"> 新增 </el-button>
        <el-button type="primary" @click="cloneStickerBtnHandle"> 克隆 </el-button>
      </el-row>
      <el-row>
        <el-table
          height="80vh"
          :data="drawPrizeList"
          style="width: 100%"
          v-loading="requestLoading"
          border
        >
          <el-table-column prop="id" label="奖励ID" align="center" />
          <el-table-column prop="awardId" label="奖品ID" align="center" />
          <el-table-column prop="replaceId" label="替换奖励ID" align="center" />
          <el-table-column prop="sortId" label="排序ID" align="center" sortable />
          <el-table-column prop="prizeName" label="名字" align="center" />
          <el-table-column prop="prizeValue" label="奖励价值" align="center" />
          <el-table-column prop="awardNums" label="奖池数量" align="center" />
          <!--  -->
          <el-table-column prop="valueType" label="价值类型" align="center" />
          <el-table-column prop="limitNums" label="一轮中获得的最大次数" align="center" />
          <el-table-column prop="sendNums" label="该奖品数量" align="center" />

          <el-table-column prop="prizeIcon" label="奖励图标" align="center">
            <template slot-scope="scope">
              <el-image
                style="width: 40px; height: auto"
                :src="scope.row.prizeIcon"
                :preview-src-list="[scope.row.prizeIcon]"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="cornerMark" label="奖励角标" align="center" />
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="addStickerBtnHandle(false, scope.row)"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row>
        <el-pagination
          :current-page.sync="pageInfo.page"
          layout="total, prev, pager, next"
          background
          @current-change="handleCurrentChange"
          :page-count="pageInfo.total"
          class="pagination"
          :page-size="30"
        >
        </el-pagination>
      </el-row>
    </el-card>
    <el-card class="card">
      <el-row class="room-sticker__title">中奖概率查询</el-row>
      <el-row class="room-sticker__search" :gutter="20">
        <!-- 选渠道查看 -->
        <el-select
          v-model="award_rate_channel"
          placeholder="请选择渠道"
          style="width: 150px"
        >
          <el-option
            v-for="(item, idx) in channelsList"
            :key="idx"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button
          @click="getRate"
          type="primary"
          :loading="rateLoading"
          :disabled="award_rate_channel == ''"
        >
          查询
        </el-button>
        <!-- tag显示 -->
        <el-tag style="margin: 0 10px" v-if="rateList.round" type="success"
          >当前轮次:{{ rateList.round }}</el-tag
        >
        <el-tag v-if="rateList.residualNums" type="success">
          剩余所有数量:{{ rateList.residualNums }}</el-tag
        >
      </el-row>
      <!-- 表格显示rateList中有residualNums/剩余的数量、round/当前的轮次
      和数组winRateBOList，里面对象有channel/该奖励的id、awardId/该奖项的数量、winRate/中奖概率、awardName/奖励名字、awardIcon/奖项图标
      遍历后显示在表格中 -->
      <el-table height="70vh" :data="rateList.winRateBOList" style="width: 100%" border>
        <el-table-column prop="awardId" label="奖励ID" align="center" />
        <el-table-column prop="awardName" label="奖励名字" align="center" />
        <el-table-column prop="awardIcon" label="奖励图标" align="center">
          <template slot-scope="scope">
            <el-image
              style="width: 40px; height: auto"
              :src="scope.row.awardIcon"
              :preview-src-list="[scope.row.awardIcon]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="winRate" label="中奖概率" align="center" />
        <el-table-column prop="awardNums" label="剩余数量" align="center" />
      </el-table>
    </el-card>
    <el-dialog
      :title="isAdd ? '新增抽奖奖励' : '编辑抽奖奖励'"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleDialogClose"
    >
      <div class="item">
        <span>奖品ID</span>
        <el-tooltip
          class="item"
          effect="dark"
          content="ID从奖励配置管理的通用奖品信息配置获取"
          placement="top-start"
        >
          <el-input v-model="submitForm.awardId" placeholder="请输入奖励ID"></el-input>
        </el-tooltip>
        <el-button 
          type="primary" 
          size="small" 
          @click="checkRewardInfo" 
          :loading="checkRewardLoading"
          style="margin-left: 10px;"
        >
          检查
        </el-button>
      </div>
      
      <!-- 奖励信息展示区域 -->
      <div class="item" v-if="rewardInfo.rewardId">
        <span>奖励信息</span>
        <div class="reward-info-display">
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="奖励ID">{{ rewardInfo.rewardId }}</el-descriptions-item>
            <el-descriptions-item label="奖励类型">{{ getRewardTypeLabel(rewardInfo.rewardType) }}</el-descriptions-item>
            <el-descriptions-item label="奖励昵称">{{ rewardInfo.rewardName }}</el-descriptions-item>
            <el-descriptions-item label="奖励价值">{{ rewardInfo.rewardPrice }}</el-descriptions-item>
            <el-descriptions-item label="真实价值">{{ rewardInfo.realPrice }}</el-descriptions-item>
            <el-descriptions-item label="奖励图标" v-if="rewardInfo.icon">
              <el-image 
                style="width: 40px; height: auto" 
                :src="rewardInfo.icon" 
                :preview-src-list="[rewardInfo.icon]"
              ></el-image>
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
      <div class="item">
        <span>渠道</span>
        <el-select v-model="submitForm.channel" placeholder="请选择渠道">
          <el-option
            v-for="(item, idx) in channelsList"
            :key="idx"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="item">
        <span>排序权重</span>
        <el-tooltip
          class="item"
          effect="dark"
          content="数字越大，越靠前"
          placement="top-start"
        >
          <el-input v-model="submitForm.sortId" placeholder="请输入排序ID"></el-input>
        </el-tooltip>
      </div>
      <!-- awardNums -->
      <div class="item">
        <span>奖池数量</span>
        <el-input v-model="submitForm.awardNums" placeholder="请输入奖池数量"></el-input>
      </div>
      <div class="item">
        <span>该奖品数量：</span>
        <el-input v-model="submitForm.sendNums" placeholder="请输入奖品数量"></el-input>
      </div>
      <div class="item">
        <span>价值类型</span>
        <el-input v-model="submitForm.valueType" placeholder="填写days、num等"></el-input>
      </div>
      <div class="item">
        <span>一轮中获得的最大次数：</span>
        <el-input v-model="submitForm.limitNums" placeholder="请输入奖品数量"></el-input>
      </div>
      <div class="item">
        <span>替换奖励ID：</span>
        <el-input v-model="submitForm.replaceId" placeholder="输入替换奖励ID"></el-input>
      </div>
      <div class="item">
        <span>角标</span>
        <el-select v-model="submitForm.cornerMark" placeholder="请选择角标">
          <el-option label="Precious" value="Precious"></el-option>
          <el-option label="Limited" value="Limited"></el-option>
          <el-option label="Top" value="Top"></el-option>
        </el-select>
      </div>
      <div class="item">
        <span>是否有效</span>
        <el-switch
          v-model="submitForm.valid"
          active-text="有效"
          inactive-text="无效"
          :active-value="1"
          :inactive-value="0"
        ></el-switch>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="uploadReqBtnHandle(0)" type="primary" v-if="isAdd">
          新 增
        </el-button>
        <el-button
          v-loading="uploadProcess"
          @click="uploadReqBtnHandle(1)"
          type="primary"
          v-else
        >
          更 新
        </el-button>
        <el-button @click="handleDialogClose">取 消</el-button>
      </span>
    </el-dialog>
    <el-drawer
      title="克隆"
      :visible.sync="isClone"
      width="50%"
      :before-close="handleCloneDialogClose"
    >
   <el-form label-width="100px" :model="cloneData">
    <el-form-item label="源渠道">
      <el-select v-model="cloneData.sourceChannel" placeholder="请选择源渠道">
        <el-option v-for="(item, idx) in channelsList" :key="idx" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="目标渠道">
      <el-select v-model="cloneData.targetChannel" placeholder="请选择目标渠道">
        <el-option v-for="(item, idx) in channelsList" :key="idx" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </el-form-item>
   </el-form>
   <div style="margin-left: 100px;">
    <el-button @click="handleCloneDialogClose">取 消</el-button>
    <el-button type="primary" @click="cloneSticker">确 定</el-button>
   </div>
    </el-drawer>
  </div>
</template>
<script>
import { rewardTypeList } from '@/components/rewardConfig/reward.js'

export default {
  data() {
    return {
      requestLoading: false,
      // 查询数据
      searchData: {
        valid: "1",
        channel: "cde",
      },
      // 总页数
      pageInfo: {
        page: 1,
        total: 0,
      },
      cloneData: {
        sourceChannel:null,
        targetChannel:null,
      },
      isClone: false,
      // 数据列表
      drawPrizeList: [],
      channelsList: this.$store.state.channels,
      submitForm: {
        awardId: "",
        channel: "",
        cornerMark: "",
        sortId: "",
        awardNums: 0,
        valid: "1",
        sendNums: 0,
        limitNums: 0,
        replaceId: "",
        valueType: "",
      },
      dialogVisible: false,
      isAdd: true,
      uploadProcess: false,

      rateLoading: false,
      award_rate_channel: "cde",
      rateList: [],
      checkRewardLoading: false,
      rewardInfo: {},
      rewardTypeList, // 导入奖励类型列表
    };
  },

  computed: {
    // 根据奖励类型值获取对应的标签
    getRewardTypeLabel() {
      return (typeValue) => {
        const type = this.rewardTypeList.find(item => item.value === typeValue);
        return type ? type.label : typeValue;
      };
    },
  },

  methods: {
    async query(page) {
      if (page) this.pageInfo.page = 1;
      this.requestLoading = true;
      const params = {
        ...this.searchData,
        page: this.pageInfo.page,
      };
      const { data: res } = await this.$axios.get(
        this.$store.getters.path.config_lottery_query +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token,
        {
          params,
        }
      );
      if (res.code !== 0) return this.$message.error(res.msg);
      this.drawPrizeList = res.data.resultList;
      this.pageInfo.total = res.data.totalPages;
      this.requestLoading = false;
    },
    // 查询按钮处理
    queryStickerBtnHandle() {
      this.query();
    },
    // 新增按钮处理
    addStickerBtnHandle(add, row) {
      this.isAdd = add;
      if (!add) {
        console.log(row);
        // row.valid = row.valid.toString();
        this.submitForm = { ...row };
      }
      this.dialogVisible = true;
    },
    cloneStickerBtnHandle() {
      this.isClone = true;
    },
    handleCloneDialogClose(){
      this.isClone = false;
      this.cloneData = {
        sourceChannel:null,
        targetChannel:null,
      };
    },
    async cloneSticker(){
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.config_lottery_clone +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token,
        {
          ...this.cloneData,
        }
      );
      if (res.code !== 0 || res.status !== 0) return this.$message.error(res.msg || res.data.message);
      this.$message.success("克隆成功");
      this.query();
    },
    async getRate() {
      // this.rateLoading = true;
      const { data: res } = await this.$axios.get(
        this.$store.getters.path.config_lottery_rate +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token,
        {
          params: {
            channel: this.award_rate_channel,
          },
        }
      );
      if (res.code !== 0) return this.$message.error(res.msg);
      this.rateLoading = false;
      console.log(res.data);
      this.rateList = res.data;
    },
    // 图片上传
    async changFile(type, file) {
      this.uploadProcess = true;
      const formData = new FormData();
      formData.append("file", file.raw);
      formData.append("cover", 0);
      formData.append("dir", "room_sticker/icon/");
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token,
        formData
      );
      this.uploadProcess = false;
      if (res.code !== 0) {
        this.$refs.upload.clearFiles();
        return this.$message.error("文件上传失败请重新选择文件上传");
      }
      this.submitForm.cornerMark = res.data;
    },
    // 新增/修改提交按钮处理
    async uploadReqBtnHandle(label) {
      let url = null;
      if (label === 0) {
        url =
          this.$store.getters.path.config_lottery_add +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token;
      } else {
        url =
          this.$store.getters.path.config_lottery_edit +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token;
      }
      const { data: res } = await this.$axios.post(url, { ...this.submitForm });
      if (res.code != 0) return this.$message.error(res.msg);
      this.handleDialogClose();
      this.query();
      this.$message.success(res.msg);
    },
    handleCurrentChange(index) {
      this.pageInfo.page = index;
      this.query();
    },

    // 弹窗关闭事件
    handleDialogClose() {
      this.submitForm = {
        awardId: "",
        channel: "",
        cornerMark: "",
        sortId: "",
        awardNums: 0,
        valid: 1,
        sendNums: 0,
        limitNums: 0,
        replaceId: "",
        valueType: "",
      };
      this.dialogVisible = false;
      this.rewardInfo = {};
    },
    
    // 检查奖励信息
    async checkRewardInfo() {
      if (!this.submitForm.awardId) {
        return this.$message.warning('请先输入奖品ID');
      }
      
      this.checkRewardLoading = true;
      try {
        const { data: res } = await this.$axios.get(
          this.$store.getters.path.config_lottery_check_reward +
            "?username=" +
            this.$store.getters.username +
            "&token=" +
            this.$store.getters.token,
          {
            params: {
              rewardId: this.submitForm.awardId,
            },
          }
        );
        
        if (res.code !== 0) {
          return this.$message.error(res.msg || res.data.message || '查询失败');
        }
        
        this.rewardInfo = res.data;
        this.$message.success('查询成功');
      } catch (error) {
        console.error('查询奖励信息失败:', error);
        this.$message.error('查询失败，请检查网络连接');
      } finally {
        this.checkRewardLoading = false;
      }
    },
  },
  mounted() {
    this.query();
    this.getRate();
  },
};
</script>
<style scoped lang="scss">
.room-sticker {
  &__title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  &__search {
    .el-select {
      margin-right: 10px;
    }
  }
}

.item {
  display: flex;
  margin: 10px 0;
  align-items: center;

  .el-input {
    margin-left: 10px;
  }

  span {
    width: 100px;
  }
}
.card {
  margin: 20px 0;
  height: 90vh;
}

.reward-info-display {
  margin-left: 10px;
  flex: 1;
  
  .el-descriptions {
    width: 100%;
  }
}
</style>
